import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { IconButtonProps } from 'components/Icons/constants';
import ArrowSimpleDownSvg from './arrowSimpleDown.svg';

export const ArrowSimpleDownIcon = (props: any) => (
  <Icon component={ArrowSimpleDownSvg} {...props} />
);

export const ArrowSimpleDownButton = ({ size = 'medium', iconSize = 24, onClick }: IconButtonProps) => (
  <Button
    type={ButtonType.OutlineIcon}
    icon={<ArrowSimpleDownIcon width={iconSize} height={iconSize} />}
    size={size}
    onClick={onClick}
  />
);
